import script from "./RectangleTool.vue?vue&type=script&lang=js"
export * from "./RectangleTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__